import { Box, Tooltip } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { memo, useCallback, useContext } from "react"
import { prioridades } from "../../../Utils/optionsEventos.js"
import { TimersContext } from "../../../Providers/Timers/TimersContext.jsx"
import moment from 'moment/moment'
import PersonImg from '../../../Assets/Imgs/person.png'
import { keyframes } from '@emotion/react'

// import { EventosContext } from "../../../Providers/EventosContext/EventosContext.jsx"

import {
    CardBottom,
    CardContainer,
    CardEventoImgPerfil,
    CardEventoImgPerfilImg,
    CardMiddle,
    CardTopo,
    Ellipsis,
    GridCardEventoImgPerfil,
    PaiEllipsis,
    spanAgrupamento
} from './SxCardEventos.js'

const CardEvento = ({ type, ev, onClick, id_ev_selecionado }) => {
    if (!ev || typeof ev != "object") {
        return false
    }

    const { entrada, evento, id, id_central, condominio, apelido, cor_borda, prioridade, descricao, agrupados, data_com_fuso } = ev
    // const data = moment.utc(ev.data).format('YYYY/MM/DD HH:mm:ss') // converte para utc
    const title_cond = `${id_central} - ${(apelido && apelido != "" ? apelido : (condominio || ''))}`
    const title_evento = `${evento} - ${descricao}`

    const { addTimer } = useContext(TimersContext)

    const handleOneClick = useCallback((e) => {
        if (onClick && typeof onClick == "function") {
            onClick(e, ev)
        }
    })

    const getCorPrioridade = useCallback((pri) => {
        if (!pri) {
            return '#000000'
        }

        let cor = prioridades.find(p => p.value == pri)
        return [cor?.color, cor?.nome]
    })

    const [corPrioridade, nomePrioridade] = getCorPrioridade(prioridade)

    // addTimer(`timer_ev_${id}`, moment(data).format('X'))
    addTimer(`timer_ev_${id}`, moment(data_com_fuso).format('X'))

    const selectedEvent = () => {
        return id_ev_selecionado
        // return (id == id_ev_selecionado)
    }

    const verifyGlobalId = () => {
        const chave = global.eventosNovos.includes(id)
        if (chave) {
            const index = global.eventosNovos.indexOf(id)
            global.eventosNovos.splice(index, 1) // Remove o item do array global.eventosNovos
        }
        return chave
    }

    // width: '98% !important',
    // margin: '4px 0 7px 0'
    // boxShadow: '3px 3px 7px 1px black'
    const blinkAnimation = keyframes`
    0% {
        border: 3px solid ${cor_borda}
    }
    50% {
        border-color: #00000000

    }
    100% {
        border: 3px solid ${cor_borda}
    }`

    const sxCard = (selectedEvent()
        ? {
            border: `3px double ${cor_borda}`
        }
        : {
            border: `2px solid ${cor_borda}`,
            ...(verifyGlobalId()
                ? { animation: `${blinkAnimation} 1s 4` }
                : {}
            )
        }
    )

    const sxColorCardTopo = (selectedEvent()
        ? {
            backgroundColor: '#8A05BE !important',
            color: 'white !important'
        }
        : {}
    )

    const sxColorCardMiddle = (selectedEvent()
        ? {
            backgroundColor: '#8a05be82 !important',
            color: 'white !important'
        }
        : {}
    )

    const sxColorCardBottom = sxColorCardTopo

    const getPathImg = () => {
        let img = ev.usuario_tratando.img_perfil
        let url = window.location.origin
        if (img == '' || img == null || img == 'null') {
            url = PersonImg
        } else {
            url += `/wsOnePortaria/images/imgUsuarios/${img}`
        }
        url = url.replace(':3003', '') // para ambiente de dev
        return url
    }

    const BoxTitleEvento = ({ title, id_ev, agrupados }) => {
        agrupados = (agrupados ? `( ${agrupados} ) ` : '')
        return (
            <Box component="div" sx={Ellipsis}>
                <Box component='span' id={'agrup_ev_' + id_ev} sx={spanAgrupamento}>{agrupados}</Box>
                <Box component='span'>{title}</Box>
            </Box>
        )
    }

    const path_img = (type == 2 ? getPathImg() : null)

    return (
        <Grid lg={12} sx={{ ...CardContainer, ...sxCard }} onClick={handleOneClick} id={`ev_${id}`} >
            <Grid container sx={{ height: 'auto' }}>
                {/* Topo do card quando quando não tem foto */}
                {type == 1 &&
                    <Grid xs={12} sx={{ height: 'auto' }} >
                        <Grid xs={12} sx={{ ...CardTopo, ...PaiEllipsis, ...sxColorCardTopo }}>
                            <Grid xs={11} sx={Ellipsis}>
                                {/* <Tooltip title={title_cond} placement="top" arrow sx={PaiEllipsis}> */}
                                <Box component="div" sx={Ellipsis}>{title_cond}</Box>
                                {/* </Tooltip> */}
                            </Grid>
                            <Grid xs={1} >
                                <Tooltip title={`Prioridade: ${nomePrioridade}`} placement="right" arrow>
                                    <Box sx={{ width: '13px', height: '13px', borderRadius: '50%', background: corPrioridade, border: `1px solid ${corPrioridade}` }}></Box>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Grid xs={12} sx={{ ...CardMiddle, ...sxColorCardMiddle, ...PaiEllipsis }} >
                            {/* <Tooltip title={title_evento} placement="right" arrow sx={PaiEllipsis}> */}
                            <Box component="div" sx={Ellipsis}>
                                <BoxTitleEvento title={title_evento} id_ev={id} agrupados={agrupados} />
                            </Box>
                            {/* </Tooltip> */}
                        </Grid>
                    </Grid>
                }

                {/* Topo do card pra quando tiver foto */}
                {type == 2 &&
                    <Grid xs={9} sx={{ height: 'auto' }} >
                        <Grid xs={12} sx={{ ...CardTopo, ...PaiEllipsis, ...sxColorCardTopo }} >
                            <Box component={'div'} sx={Ellipsis}>
                                {/* <Tooltip title={title_cond} placement="top" arrow sx={PaiEllipsis}> */}
                                <Box component="div" sx={Ellipsis}>{title_cond}</Box>
                                {/* </Tooltip> */}
                            </Box>
                        </Grid>
                        <Grid xs={12} sx={{ ...CardMiddle, ...sxColorCardMiddle, ...PaiEllipsis }} >
                            <Box component={'div'} sx={Ellipsis}>
                                {/* <Tooltip title={title_evento} placement="right" arrow sx={PaiEllipsis}> */}
                                <Box component="div" sx={Ellipsis}>
                                    <BoxTitleEvento title={title_evento} id_ev={id} agrupados={agrupados} />
                                </Box>
                                {/* </Tooltip> */}
                            </Box>
                        </Grid>
                    </Grid>
                }

                {/* Foto */}
                {type == 2 &&
                    <Grid xs={3} sx={GridCardEventoImgPerfil}>
                        <Tooltip title={ev.usuario_tratando.nome} placement="right" arrow sx={PaiEllipsis}>
                            <div style={CardEventoImgPerfil}>
                                <img style={CardEventoImgPerfilImg} src={path_img}></img>
                            </div>
                        </Tooltip>
                    </Grid>
                }
            </Grid>

            {/* Bottom */}
            <Grid container sx={{ ...CardBottom, ...sxColorCardBottom }} >
                <Grid xs={7} sx={PaiEllipsis}>
                    {/* <Tooltip title={entrada} placement="bottom" arrow sx={PaiEllipsis}> */}
                    <Box component={'div'} sx={Ellipsis}>{entrada}</Box>
                    {/* </Tooltip> */}
                </Grid>
                <Grid xs={5} sx={{ ...PaiEllipsis, textAlign: 'end', fontSize: '10 px' }}>
                    <Box component={'div'} id={'timer_ev_' + id} sx={Ellipsis}></Box>
                </Grid>
            </Grid>

        </Grid>
    )
}

export default memo(CardEvento)
